import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Flex,
  Box,
  Text,
  Button,
  VStack,
  Image,
  Stack,
} from "@chakra-ui/react";

import img1 from "../../assets/intro-image.png";

const IntroductionPage = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/register");
  };

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <Flex
      justify="center"
      align="center"
      height="100vh"
      bg="white"
      border="1px solid #2a4567"
      position="relative"
      boxShadow="0px 4px 20px rgba(0, 0, 0, 0.25)"
    >
      {/* Left Content – 70% */}
      <Box
        flex="0 0 70%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        px={10}
      >
        <VStack align="center" spacing={5} maxW="700px">
          <Text
            fontFamily="PlusJakartaSansSemiBold"
            fontSize="48px"
            lineHeight="60px"
            color="#000"
            textTransform="uppercase"
            textAlign={'center'}
          >
            Selling with Kidswear collective
          </Text>

          {/* Bullet Points */}
          <VStack textAlign={"center"} spacing={2}>
            <Text
              fontFamily="PlusJakartaSansRegular"
              fontSize="18px"
              lineHeight="28px"
              color="#898989"
            >
              We are the award-winning rescale and outlet platform for designer
              Kidswear. We work with the leading retailers and brands and sell
              online and across department stores.
            </Text>
            <Text
              fontFamily="PlusJakartaSansRegular"
              fontSize="18px"
              lineHeight="28px"
              color="#898989"
            >
              Selling unwanted baby and kidswear is a great way to clear space in your wardrobe, earn money and support circular
              fashion and a sustainable lifestyle.
            </Text>
            <Text
              fontFamily="PlusJakartaSansRegular"
              fontSize="18px"
              lineHeight="28px"
              color="#898989"
            >
              To become a private seller with us please register you details and we'll be in touch.
            </Text>
          </VStack>

          {/* Buttons */}
          <Flex gap={4} justifyContent={'center'} alignItems={'center'} pt={10}>
            <Button
              bg="#000"
              borderRadius="12px"
              fontFamily="PlusJakartaSansSemiBold"
              fontSize="16px"
              color="#FFF"
              w="200px"
              h="48px"
              onClick={() => navigate("/faqs")}
              textTransform={'uppercase'}
            >
              Get Started
            </Button>
          </Flex>
        </VStack>
      </Box>

      {/* Right Image – 30% */}
      <Box flex="0 0 30%" paddingRight={10}>
        <Image
          src={img1}
          alt="Kids Fashion"
          objectFit="cover"
          width="100%"
          height="100%"
        />
      </Box>
    </Flex>
  );
};

export default IntroductionPage;
